import { Dialog } from "@angular/cdk/dialog";
import { CommonModule } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import { Icon, IconPower, IconRegistryService, PaxIcon } from "pax-ui/icons";

import { DialogComponent } from "../dialog";
import { FunnelHeaderMilestone } from "../funnel-header";
import { Section } from "../section";

@Component({
  standalone: true,
  selector: "pax-progress-bar",
  styleUrls: ["./progress-bar.scss"],
  templateUrl: "./progress-bar.html",
  imports: [CommonModule, Section, Icon],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressBar implements OnInit {
  @Input({ required: true }) allMilestones!: FunnelHeaderMilestone[];

  @ViewChild("progressOverview")
  progressOverviewDialog!: TemplateRef<HTMLElement>;

  lastMilestoneIcon: PaxIcon = IconPower;

  currentStepIndex = 0;
  currentMilestoneIndex = 0;

  constructor(
    private readonly _router: Router,
    private readonly dialog: Dialog,
    readonly iconRegistryService: IconRegistryService,
  ) {
    iconRegistryService.registerIcons([this.lastMilestoneIcon]);
  }

  ngOnInit(): void {
    this.getCurrentStepIndex();
  }

  private getCurrentStepIndex() {
    const currentSteps = this.allMilestones.map((milestone) =>
      milestone.steps.filter(({ path }) => {
        return this._router.url.includes(path);
      }),
    );

    currentSteps.forEach((steps, milestoneIndex) => {
      if (steps.length > 0) {
        if (steps.length > 1) {
          let errorMessage = `Found more than one matching registered route. The current url '${this._router.url}' has matched with the following urls: `;
          steps.forEach((step, index) => {
            const isLastItem = steps.length - 1 === index;
            errorMessage += `'${step.path}'`;
            if (!isLastItem) {
              errorMessage += ", ";
            }
          });

          throw Error(errorMessage);
        }

        this.currentMilestoneIndex = milestoneIndex;
      }
    });

    if (currentSteps.length === 0) {
      throw Error(
        `Could not find a matching registered route for the current url '${this._router.url}'`,
      );
    }

    this.currentStepIndex =
      this.allMilestones[this.currentMilestoneIndex]?.steps.findIndex(
        ({ path }) => {
          return this._router.url.includes(path);
        },
      ) ?? 0;
  }

  showProgressOverview() {
    this.dialog.open<DialogComponent>(DialogComponent, {
      width: "clamp(300px, 70%, 600px)",
      height: "auto",
      data: {
        contentTemplate: this.progressOverviewDialog,
        showCloseButton: true,
      },
    });
  }
}
